import { Navigate } from "react-router-dom";
import { JSX, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }: {children: JSX.Element}) => {
    const auth = useContext(AuthContext);
    return auth?.user ? children:<Navigate to="/login" />
};

export default ProtectedRoute;